import { GetContextMenuItemsParams } from 'ag-grid-community'

export const processDataFromClipboard = (params: GetContextMenuItemsParams) => {
  if (params.column?.getColId() === 'infoMessage' && params.value?.length) {
    return params.value.replace(/(\r\n|\n|\r)/gm, '')
  }
  const colDef: any = params.column?.getColDef()
  if (colDef.valueFormatter) {
    return colDef.valueFormatter({
      ...params,
      data: params.node?.data,
      colDef,
    })
  }
  const activeElement = document.activeElement as HTMLInputElement
  let selectionText = params.value
  if (
    activeElement?.tagName === 'INPUT' &&
    params.column?.getColId() === 'productGenericDescriptionText'
  ) {
    selectionText = activeElement.value?.slice(
      activeElement.selectionStart ?? 0,
      activeElement.selectionEnd ?? 0
    )
  }
  return selectionText
}
